import { Component, OnInit } from '@angular/core';
import { DocumentService } from '../../../../services/document.service';
import { CommonService } from '../../../../services/common.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../../services/authentication.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-document-detail',
  templateUrl: './document-detail.component.html',
  styleUrls: ['./document-detail.component.scss']
})
export class DocumentDetailComponent implements OnInit {


    pagecode: string = "gistec-document";
    module: string = "gistec";
    accessdenied: boolean = false;
    folders: any[] = [];
    documentTypes: any[] = [];

    hasExpiryDate: boolean = false;
    expiryDate: string;
    ccAddLoading: boolean = false;
    ccDeleteLoading: boolean = false;

    newFollowerEmail: string = "";

    btnVerifyDisabled: boolean = false;
    btnVerifyText: string = "Update";

    documentId: string;

    

    document: any;

    deleteDocument() {
        this.documentService.deleteDocument(this.documentId, this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data) {
                        this.common.ShowMessage('info', 'The file has been deleted', '');
                        this._router.navigate(['gistec/document/list']);
                    }
                    else {
                        this.common.ShowMessage('info', 'Error in deleteing file. please contact mygistec administrator', '');
                    }
                }
                else {
                    console.error("Web/gistec/documents/deleteDocument()", res.error_message);
                }

            },
            (err: any) => {
                console.error("Web/gistec/documents/deleteDocument()", err);
            }
        );
    }
    addFollower(email: any) {

        if (!this.common.ValidateEmail(email).valid) {
            this.common.ShowMessage('info', 'invalid email address [' + email + ']', '');
            return;
        }

        var isexisting = this.document.usersAccess.find(s => s.email.toLowerCase() == email.toLowerCase());
        if (isexisting) {
            this.common.ShowMessage('info', 'The email is already exists in the list', '');
        }
        else {
            this.ccAddLoading = true;
            this.documentService.addFollower(this.documentId, email, this.authentication._authentication.id).subscribe(
                (res: any) => {
                    if (res.success) {

                        if (res.data) {
                            this.document.usersAccess.push(res.data);
                        }
                        this.newFollowerEmail = "";
                        this.ccAddLoading = false;
                    }
                    else {
                        this.ccAddLoading = false;
                        console.error("Web/gistec/documents/addFollower()", res.error_message);
                    }

                },
                (err: any) => {
                    this.ccAddLoading = false;
                    console.error("Web/gistec/documents/addFollower()", err);
                }
            );
        }

        

    }
    deleteFollower(id: any, index: any) {
        this.documentService.deleteFollower(id, this.authentication._authentication.id).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data) {
                        this.common.ShowMessage('info', 'The user has been deleted', '');
                        this.document.usersAccess.splice(index, 1);
                    }
                    else {
                        this.common.ShowMessage('info', 'Error in deleteing the user. please contact mygistec administrator', '');
                    }
                }
                else {
                    console.error("Web/gistec/documents/deleteFollower()", res.error_message);
                }

            },
            (err: any) => {
                console.error("Web/gistec/documents/deleteFollower()", err);
            }
        );
    }

    update() {
        debugger;
        
        var expireDate = "";
        if (this.hasExpiryDate) {
            expireDate = this.expiryDate;
        }
        var obj = {
            documentId: this.documentId,
            folderId: this.SelectedFolder.id,
            typeId: this.SelectedType.id,
            description: this.document.file.description,
            hasExpiryDate: this.hasExpiryDate,
            expiryDate: expireDate
        };


        this.btnVerifyDisabled = true;
        this.documentService.updateDocument(obj).subscribe(
            (res: any) => {
                //console.log("res", res);
                this.btnVerifyDisabled = false;
                if (res) {
                    this.common.ShowMessage("info", "The document is updated successfully. Thank you", "");
                }
            },
            (err: any) => {
                console.error("err", err);
                this.btnVerifyDisabled = false;
            }
        );




    }

    getDocumentById_admin() {
        this.documentService.getDocumentById_admin(this.documentId).subscribe(
            (res: any) => {
                if (res.success) {
                    if (res.data) {
                        this.document = res.data;
                        this.document.file.fileSize_mb = 0;
                        if (this.document.file.fileSize)
                            this.document.file.fileSize_mb = parseFloat((this.document.file.fileSize / 1024 / 1024).toString()).toFixed(2);

                        debugger;
                        if (this.document.file.expireDate != null) {
                            this.hasExpiryDate = true;
                            this.expiryDate = this.document.file.expireDate;
                        }
                        debugger;
                        this.getDocumentCenterFolders();
                        this.getDocumentTypes();
                    }
                }
                else {
                    console.error("Web/gistec/documents/getDocumentById_admin()", res.error_message);
                }

            },
            (err: any) => {
                console.error("Web/gistec/documents/getDocumentById_admin()", err);
            }
        );
    }

    downloadFile() {
        debugger;
        var link = document.createElement('a');
        link.href = this.document['file'].contentBase64;
        var fileName = this.document['file'].fileName;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    }
    documentURL: string = "";
    constructor(private route: ActivatedRoute, private _router: Router, private documentService: DocumentService, private authentication: AuthenticationService, private common: CommonService) {

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        let map: any = this.route.paramMap;
                        this.documentId = map.destination._value.id;

                        this.documentURL = environment.mygistecUrl + "/d/" + this.documentId;

                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data
                        this.getDocumentById_admin();

                        //
                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });

    }
    
    ngOnInit(): void {
        
    }
    getDocumentCenterFolders() {
        this.documentService.getDocumentCenterFolders().subscribe(
            (res: any) => {
                if (res.success) {
                    for (var i = 0; i < res.data.length; i++) {
                        var selected = false;
                        if (this.document.file.folderId == res.data[i].id) {
                            selected = true;
                            this.SelectedFolder = res.data[i];
                        }
                        this.folders.push({
                            id: res.data[i].id,
                            folderName: res.data[i].folderName,
                            selected: selected
                        });
                    }
                }
                else {
                    console.error("Web/gistec/documents/getDocumentCenterFolders()", res.error_message);
                }

            },
            (err: any) => {
                console.error("Web/gistec/documents/getDocumentCenterFolders()", err);
            }
        );
    }
    SelectedFolder: any = '';
    selectFolderOption(evt: any) {
        debugger;
        var optionValue = evt.target.value;
        var item = this.folders.find(s => s.id == optionValue);
        this.SelectedFolder = item;
        
    }


    getDocumentTypes() {
        this.documentService.getDocumentTypes().subscribe(
            (res: any) => {
                if (res.success) {

                    for (var i = 0; i < res.data.length; i++) {
                        var selected = false;
                        if (this.document.file.typeId == res.data[i].id) {
                            selected = true;
                            this.SelectedType = res.data[i];
                        }
                        this.documentTypes.push({
                            id: res.data[i].id,
                            type: res.data[i].type,
                            selected: selected
                        });
                    }

                }
                else {
                    console.error("Web/gistec/documents/getDocumentCenterFolders()", res.error_message);
                }
            },
            (err: any) => {
                console.error("Web/gistec/documents/getDocumentCenterFolders()", err);
            }
        );
    }
    SelectedType: any = '';
    selectTypeOption(evt: any) {

        var optionValue = evt.target.value;
        var item = this.documentTypes.find(s => s.id == optionValue);
        this.SelectedType = item;

    }
}
